<template>
  <div>
    <ul class="apartment-info">
      <li><b>Org.nr:</b> {{ organizationNumber }}</li>
      <li v-if="company.ceo"><b>VD:</b> {{ company.ceo }}</li>
      <li v-else-if="company.chairman">
        <b>Ordförande:</b> {{ company.chairman }}
      </li>
      <li v-else-if="company.boardMember">
        <b>Ledamot:</b> {{ company.boardMember }}
      </li>
      <li>
        <b>SNI-branch:&nbsp;</b>
        <span
          v-html="
            company.sni && company.sni.replace(/(?=\d{5} )/g, '<br />').trim()
          "
        />
      </li>
      <li>
        <b>Registreringsdatum:</b>
        {{ new Date(company.registrationDate).toLocaleDateString('sv-SE') }}
      </li>
      <li v-if="company.employeesAmount">
        <b>Antal anställda:</b>
        {{ company.employeesAmount }}
      </li>
      <template v-if="secondaryTenant">
        <li>
          <b>Faktureringsadress:</b>
          {{ secondaryTenant.billingAddress }}
        </li>
        <li>
          <b>E-post för fakturering:</b>
          {{ secondaryTenant.billingEmail }}
        </li>
      </template>
      <li>
        <BaseIconText
          class="icon-holder"
          size="smaller"
          :icon-url="getIcon(company.moms)"
        >
          Moms
        </BaseIconText>
      </li>
      <li>
        <BaseIconText
          class="icon-holder"
          size="smaller"
          :icon-url="getIcon(company.fSkatt)"
        >
          F-skatt
        </BaseIconText>
      </li>
      <li>
        <BaseIconText
          class="icon-holder"
          size="smaller"
          :icon-url="getIcon(company.arbetsgivaravgift)"
        >
          Arbetsgivaravgift
        </BaseIconText>
      </li>
    </ul>
    <template v-if="firstAccounting"
      ><br />
      <GenericH4>
        <b>Resultaträkning {{ firstAccounting.year }}</b>
      </GenericH4>
      <ul class="apartment-info">
        <li><b>Omsättning:</b> {{ firstAccounting.revenue }} kr</li>
        <li><b>Resultat:</b> {{ firstAccounting.netProfit }} kr</li>
      </ul></template
    >
  </div>
</template>
<script>
import svgs from '@/utils/icon-constants';

import BaseIconText from '@/components/BaseIconText.vue';
import GenericH4 from '@/components/GenericH4.vue';

export default {
  components: {
    BaseIconText,
    GenericH4
  },
  props: {
    company: {
      type: Object,
      default: () => ({})
    },
    secondaryTenant: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      svgs
    };
  },
  computed: {
    organizationNumber() {
      return this.company?.organizationNumber
        ? this.formatOrgNr(this.company.organizationNumber)
        : this.company?.organizationNumber;
    },
    sortedAccounting() {
      if (!this.company?.accounting?.length) {
        return [];
      }
      return [...this.company.accounting].sort((a, b) => {
        return b.year.localeCompare(a.year);
      });
    },
    firstAccounting() {
      if (!this.sortedAccounting?.length) {
        return null;
      }
      return this.sortedAccounting[0];
    }
  },
  methods: {
    formatOrgNr(input) {
      const s = String(input).trim().replace(/[\s-]/g, '').slice(-10);
      return s.length <= 4 ? s : s.slice(0, -4) + '-' + s.slice(-4);
    },
    getIcon(val) {
      return val ? this.svgs.ICONS.CHECK_GREEN : this.svgs.ICONS.ERROR_RED;
    }
  }
};
</script>

<style scoped>
ul li {
  font-weight: 400;
  font-size: 13px;
  line-height: 1.6;
}
ul li b {
  font-weight: 600;
}
.icon-holder {
  margin: 0.5rem 0;
}
</style>
